const sumUp = () => {

    if ( $('.js-sumUp').length < 1 ) {
        return
    }

    const $output = $('.js-sumUp .js-sumUp__output');

    const sumUp = () => {
        let sum = 0;
        $('.js-sumUp__field').each(function() {
            const value = parseFloat($(this).val());
            if ( isNaN(value) ) {
                return
            }
            sum += value;
        });
        $output.find('.js-sumUp__value').text(`£${sum.toFixed(2)}`);
        if ( sum === 0 ) {
            $output.hide();
        }
        else {
            $output.show();
        }
    }

    $(document).on('keyup', '.js-sumUp__field', sumUp)
    $(document).on('sumUp', sumUp)
};

sumUp();
